import { Directive, TemplateRef } from '@angular/core';
/** A simple directive used by FieldsetGridComponent to access the TemplateRef of grid items */
@Directive({
  selector: '[ngkFieldsetGridItem]',
})
export class FieldsetGridItemDirective {
  constructor(public templateRef: TemplateRef<unknown>) {}
}
